import React from 'react';

import { Modal, ModelHeader, ModalBody, ModalFooter } from '../../common/input/modal/Modal';
import logoimg from '../../assets/images/logo.png';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import trash_icon from '../../assets/images/icons/user-dashboard/trash-icon.png';
// import "./customModalView.scss";

const ShiftModalView = (props) => {
    const style1 = {
        "&:hover": {
            "transform": "scale(1.5) !important",
        }
    }
    console.log("SHIFT-DETAILS", props.shift_detail)
    return (
        <>
            <Modal className="price-calculator-popup" show={props.shift_modal_show} onHide={props.hideShiftModal}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="price-calculator-pop-cont-wrap">
                                <ModelHeader>
                                    <div className="price-calculator-pop-header">
                                        <h4>Shifts !!</h4>
                                    </div>
                                </ModelHeader>
                                <ModalBody>
                                    <div className="table-area applied-job-table" style={{ margin: '8px' }}>
                                        <Table responsive>
                                            <thead>
                                                <tr>
                                                    <th>Shift id</th>
                                                    <th>Shift Number</th>
                                                    <th>Candidate Name</th>
                                                    <th>Start date</th>
                                                    <th>End Date</th>
                                                    <th>Start Time</th>
                                                    <th>End Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {props.shift_detail.map((shift, index) => (
                                                    <tr>
                                                        <td>{shift.id}</td>
                                                        <td>{shift.shift_number}</td>
                                                        <td> {shift.allotted_candidate_full_name}</td>
                                                        <td>{shift.start_date}</td>
                                                        <td>{shift.end_date}</td>
                                                        <td>{shift.start_date_arrival_time}</td>
                                                        <td>{shift.start_date_departure_time}</td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <div className="wage-pop-footer">
                                        <div className="logo"><img src={logoimg} alt="" /></div>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default ShiftModalView;
